import { combineReducers } from "redux";
import thermostat_devices from "./thermostat_devices";
import battery_devices from "./battery_devices";
import unassigned_battery_devices from "./unassigned_battery_devices";

export default combineReducers({
  thermostat_devices,
  battery_devices,
  unassigned_battery_devices,
});
